import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { main } from "./utils/configuration";
import { handleLoginRedirect } from "./utils/configuration/login/redirect";
import { config } from "./config";
import RouteView from "./screens/RouteView";
import StopView from "./screens/StopView";

const renderApplication = () => {
  createRoot(document.getElementById("root") as HTMLElement).render(<App />);
};

const renderPublic = () => {
  createRoot(document.getElementById("root") as HTMLElement).render(<RouteView />);
}

const renderPublicStop = () => {
  createRoot(document.getElementById("root") as HTMLElement).render(<StopView />);
}

if (config.publicStopRoute && window.location.href.startsWith(config.publicStopRoute)) {
  renderPublicStop();
} else if (window.location.href.startsWith(config.publicRoute as string)) {
  renderPublic();
} else if (window.location.href.startsWith(config.login.redirectUri as string)) {
  handleLoginRedirect();
} else {
  main(renderApplication);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
